import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/nominas/periodos-de-seguro-imss-detalles';

/**
 * GET periodos pago IMSS
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPeriodosPagoIMSSDetalle = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET periodo pago IMSS por ID
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPeriodoPagoIMSSDetalle = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo de Seguridad Social
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPeriodoPagoIMSSDetalle = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH periodo pago IMSS
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPeriodoPagoIMSSDetalle = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE periodo pago IMSS
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePeriodoPagoIMSSDetalle = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR periodo pago IMSS
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarPeriodoPagoIMSSDetalle = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
